"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _snakeymouse = require("./snakeymouse1");

Object.keys(_snakeymouse).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _snakeymouse[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _snakeymouse[key];
    }
  });
});